import CONST from "./Constant";

const INITIAL_STATE = {
    list:[],
    selected:{},
    error: [],
    code: "",
    config:{
        from:0,
        to:0,
        lastPage:1,
        rowCount:0,
        pagination:{
            page:0,
            pageSize:10,
        },
        filters:{
            keyword:'',
            year: null,
            week: null,
            sort_by:'start_date',
            sort_dir:'desc',
        }
    },
    dirty: false,
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.SET_SELECTED_ITEM:
            return {
                ...state,
                selected: action.payload,
            }
        case CONST.FETCH_ITEM_SUCCESS:
            return {
                ...state,
                selected: action.payload.data,
                error: [],
                message: ["Roster loaded successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_ITEMS_SUCCESS:
            return action.payload.config.params.paginate === undefined ? {
                ...state,
                list:action.payload.data.data,
                config:{
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Rosters loaded successfully"],
            } : {
                ...state,
                list: action.payload.data,
                error: [],
                code:action.payload.status,
                message: ["Rosters loaded successfully"],
            }
        case CONST.FETCH_ITEM_FAILED:
        case CONST.FETCH_ITEMS_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }
        default:
            return state;
    }
}

export default Reducer ;

